// extracted by mini-css-extract-plugin
export default {"container":"EmptyState_container__DvU0x","icon":"EmptyState_icon__XZQlp"};